import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useToast } from '_/hooks/use-toast'

import { Grid } from '@mui/material'
import { Datagrid } from '@refera/ui-web'

import HeaderTitle from '_/components/header-title'

import useStyles from './styles'

import { profileColumns, TABLE_SX } from './constants'
import { navigate } from '@reach/router'
import { ROUTES } from '_/utils/constants'
import { agencySelector } from '_/modules/agency/selectors'
import { getReportsListSelector } from '_/modules/reports/selector'
import { getReportsList } from '_/modules/reports/actions'

export default function Report() {
  const dispatch = useDispatch()
  const styles = useStyles()
  const agency = useSelector(agencySelector)

  const [isLoading, setIsLoading] = useState(false)

  const reports = useSelector(getReportsListSelector) ?? []
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(25)
  const [orderBy, setOrderBy] = useState('title')
  const [formStateDefault, setFormStateDefault] = useState(reports || [])

  const { showToast } = useToast()

  const handleOrderBy = useCallback(
    orderObj => {
      const order = orderObj[0]
      if (!order) {
        handleOrderBy('title')
        return
      }
      const { field, sort } = order
      sort === 'desc' ? setOrderBy(`-${field}`) : setOrderBy(field)
    },
    [setOrderBy]
  )

  const getReportList = useCallback(() => {
    setIsLoading(true)

    return dispatch(
      getReportsList({
        contractType: agency?.contractType,
        pageSize,
        page: page + 1,
        orderBy,
      })
    )
      .then(data => {
        setFormStateDefault(data?.results || [])
        return setIsLoading(false)
      })
      .catch(() => {
        showToast({ type: 'error', message: 'Ocorreu um erro ao buscar as macro etapas.' })
        return setIsLoading(false)
      })
  }, [dispatch, orderBy, page, pageSize, agency])

  const handleCellClick = useCallback(({ row }) => {
    // if (
    //   checkIfUserDoesNotPermission(PERMISSIONS.PERMISSION_GROUPS, [
    //     PERMISSIONS_ACTIONS.ADD,
    //     PERMISSIONS_ACTIONS.EDIT,
    //   ])
    // ) {
    //   return
    // }
    return navigate(`${ROUTES.REPORTS_DETAIL}/${row?.id}`)
  }, [])

  const goBack = () => {
    window?.history?.length <= 2 ? navigate(`/`) : navigate(-1)
  }

  useEffect(() => {
    getReportList()
  }, [orderBy, page, pageSize, agency])

  return (
    <Grid className={styles.page}>
      <HeaderTitle title="Relatórios" backButtonAction={goBack} />
      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            initialState={{
              sorting: {
                sortModel: [{ field: 'title', sort: 'asc' }],
              },
            }}
            loading={isLoading}
            rows={formStateDefault}
            columns={profileColumns()}
            onCellClick={handleCellClick}
            rowCount={formStateDefault?.length || 0}
            sx={TABLE_SX}
            noRowsLabel="Nenhum resultado encontrado"
            paginationMode="server"
            onPageChange={setPage}
            page={page}
            onPageSizeChange={setPageSize}
            pageSize={pageSize}
            onSortModelChange={handleOrderBy}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
